import { createSlice } from '@reduxjs/toolkit'

import { TempState } from './temp.type'

const initialState: TempState = {
  checkUserFollow: [],
  isLinkX: false,
}

const tempSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCheckUserFollow: (state, action) => {
      const { id } = action.payload
      const listFollowed = Array.from(state.checkUserFollow)
      const findUser = listFollowed.find((it) => it.id === id)
      if (findUser) {
        state.checkUserFollow = listFollowed.filter((it) => it.id !== id)
      } else {
        state.checkUserFollow.push(action.payload)
      }
    },
    setIsLinkX: (state, action) => {
      state.isLinkX = action.payload
    },
  },
  extraReducers: () => {},
})

export const tempActions = tempSlice.actions
const tempReducer = tempSlice.reducer
export default tempReducer
